/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.7.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { getAuth0Token, getVectorBaseUrl, transformApiResult, transformRequestOptions } from './VectorClientHelpers';
export class VectorClientBase { 

    protected transformOptions(options: any) {
        return this.getToken().then(newToken => transformRequestOptions(newToken, options));
      }
  
  protected transformResult(url: string, response: Response, processor: (response: Response) => any) {
    return transformApiResult(url, response, processor);
  }

  protected getBaseUrl(urlTemplate: string, defaultUrl: string | undefined): string {
    return getVectorBaseUrl(urlTemplate, defaultUrl);
  }

  private async getToken() {
    return getAuth0Token();
  }
}

export interface IDecksClient {
    /**
     * @return Success
     */
    cardsAll(vaultId: number, deckId: number): Promise<CardApiModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    cardsPOST(vaultId: number, deckId: number, body?: CardCreationRequest | undefined): Promise<CardApiModel>;
    /**
     * @return Success
     */
    cardsGET(vaultId: number, deckId: number, cardId: number): Promise<CardApiModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    cardsPUT(vaultId: number, deckId: number, cardId: number, body?: CardUpdateRequest | undefined): Promise<CardApiModel>;
    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    cardsDELETE(vaultId: number, deckId: number, cardId: number, shouldDelete?: boolean | undefined): Promise<void>;
    /**
     * @return Success
     */
    decksAll(vaultId: number): Promise<DeckApiModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    decksPOST(vaultId: number, body?: DeckCreationRequest | undefined): Promise<DeckApiModel>;
    /**
     * @return Success
     */
    decksGET(vaultId: number, deckId: number): Promise<DeckApiModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    decksPUT(vaultId: number, deckId: number, body?: DeckUpdateRequest | undefined): Promise<DeckApiModel>;
    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    decksDELETE(vaultId: number, deckId: number, shouldDelete?: boolean | undefined): Promise<DeckApiModel>;
}

export class DecksClient extends VectorClientBase implements IDecksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    cardsAll(vaultId: number, deckId: number): Promise<CardApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/decks/{deckId}/Cards";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (deckId === undefined || deckId === null)
            throw new Error("The parameter 'deckId' must be defined.");
        url_ = url_.replace("{deckId}", encodeURIComponent("" + deckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCardsAll(_response));
        });
    }

    protected processCardsAll(response: Response): Promise<CardApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CardApiModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cardsPOST(vaultId: number, deckId: number, body?: CardCreationRequest | undefined): Promise<CardApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/decks/{deckId}/Cards";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (deckId === undefined || deckId === null)
            throw new Error("The parameter 'deckId' must be defined.");
        url_ = url_.replace("{deckId}", encodeURIComponent("" + deckId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCardsPOST(_response));
        });
    }

    protected processCardsPOST(response: Response): Promise<CardApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CardApiModel>(<any>null);
    }

    /**
     * @return Success
     */
    cardsGET(vaultId: number, deckId: number, cardId: number): Promise<CardApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/decks/{deckId}/Cards/{cardId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (deckId === undefined || deckId === null)
            throw new Error("The parameter 'deckId' must be defined.");
        url_ = url_.replace("{deckId}", encodeURIComponent("" + deckId));
        if (cardId === undefined || cardId === null)
            throw new Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{cardId}", encodeURIComponent("" + cardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCardsGET(_response));
        });
    }

    protected processCardsGET(response: Response): Promise<CardApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CardApiModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cardsPUT(vaultId: number, deckId: number, cardId: number, body?: CardUpdateRequest | undefined): Promise<CardApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/decks/{deckId}/Cards/{cardId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (deckId === undefined || deckId === null)
            throw new Error("The parameter 'deckId' must be defined.");
        url_ = url_.replace("{deckId}", encodeURIComponent("" + deckId));
        if (cardId === undefined || cardId === null)
            throw new Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{cardId}", encodeURIComponent("" + cardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCardsPUT(_response));
        });
    }

    protected processCardsPUT(response: Response): Promise<CardApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CardApiModel>(<any>null);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    cardsDELETE(vaultId: number, deckId: number, cardId: number, shouldDelete?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/decks/{deckId}/Cards/{cardId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (deckId === undefined || deckId === null)
            throw new Error("The parameter 'deckId' must be defined.");
        url_ = url_.replace("{deckId}", encodeURIComponent("" + deckId));
        if (cardId === undefined || cardId === null)
            throw new Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{cardId}", encodeURIComponent("" + cardId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCardsDELETE(_response));
        });
    }

    protected processCardsDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    decksAll(vaultId: number): Promise<DeckApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Decks";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDecksAll(_response));
        });
    }

    protected processDecksAll(response: Response): Promise<DeckApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeckApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeckApiModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    decksPOST(vaultId: number, body?: DeckCreationRequest | undefined): Promise<DeckApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Decks";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDecksPOST(_response));
        });
    }

    protected processDecksPOST(response: Response): Promise<DeckApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeckApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeckApiModel>(<any>null);
    }

    /**
     * @return Success
     */
    decksGET(vaultId: number, deckId: number): Promise<DeckApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Decks/{deckId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (deckId === undefined || deckId === null)
            throw new Error("The parameter 'deckId' must be defined.");
        url_ = url_.replace("{deckId}", encodeURIComponent("" + deckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDecksGET(_response));
        });
    }

    protected processDecksGET(response: Response): Promise<DeckApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeckApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeckApiModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    decksPUT(vaultId: number, deckId: number, body?: DeckUpdateRequest | undefined): Promise<DeckApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Decks/{deckId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (deckId === undefined || deckId === null)
            throw new Error("The parameter 'deckId' must be defined.");
        url_ = url_.replace("{deckId}", encodeURIComponent("" + deckId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDecksPUT(_response));
        });
    }

    protected processDecksPUT(response: Response): Promise<DeckApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeckApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeckApiModel>(<any>null);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    decksDELETE(vaultId: number, deckId: number, shouldDelete?: boolean | undefined): Promise<DeckApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Decks/{deckId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (deckId === undefined || deckId === null)
            throw new Error("The parameter 'deckId' must be defined.");
        url_ = url_.replace("{deckId}", encodeURIComponent("" + deckId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDecksDELETE(_response));
        });
    }

    protected processDecksDELETE(response: Response): Promise<DeckApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeckApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeckApiModel>(<any>null);
    }
}

export class CardApiModel implements ICardApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    text?: string | undefined;
    tags?: string[] | undefined;

    constructor(data?: ICardApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
            this.text = _data["text"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): CardApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new CardApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        data["text"] = this.text;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data; 
    }
}

export interface ICardApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    text?: string | undefined;
    tags?: string[] | undefined;
}

export class CardCreationRequest implements ICardCreationRequest {
    text!: string;
    tags!: string[];
    legacyKnowledgebaseId?: string | undefined;

    constructor(data?: ICardCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
        }
    }

    static fromJS(data: any): CardCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CardCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        return data; 
    }
}

export interface ICardCreationRequest {
    text: string;
    tags: string[];
    legacyKnowledgebaseId?: string | undefined;
}

export class CardUpdateRequest implements ICardUpdateRequest {
    newParentId!: number;
    text!: string;
    tags!: string[];
    legacyKnowledgebaseId?: string | undefined;

    constructor(data?: ICardUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newParentId = _data["newParentId"];
            this.text = _data["text"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
        }
    }

    static fromJS(data: any): CardUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CardUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newParentId"] = this.newParentId;
        data["text"] = this.text;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        return data; 
    }
}

export interface ICardUpdateRequest {
    newParentId: number;
    text: string;
    tags: string[];
    legacyKnowledgebaseId?: string | undefined;
}

export class DeckApiModel implements IDeckApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    tags?: string[] | undefined;
    cardCount?: number;
    cards?: CardApiModel[] | undefined;

    constructor(data?: IDeckApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.cards) {
                this.cards = [];
                for (let i = 0; i < data.cards.length; i++) {
                    let item = data.cards[i];
                    this.cards[i] = item && !(<any>item).toJSON ? new CardApiModel(item) : <CardApiModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.cardCount = _data["cardCount"];
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(CardApiModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeckApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeckApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["cardCount"] = this.cardCount;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeckApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    tags?: string[] | undefined;
    cardCount?: number;
    cards?: ICardApiModel[] | undefined;
}

export class DeckCreationRequest implements IDeckCreationRequest {
    title!: string;
    description?: string | undefined;
    tags!: string[];
    legacyKnowledgebaseId?: string | undefined;

    constructor(data?: IDeckCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
        }
    }

    static fromJS(data: any): DeckCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeckCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        return data; 
    }
}

export interface IDeckCreationRequest {
    title: string;
    description?: string | undefined;
    tags: string[];
    legacyKnowledgebaseId?: string | undefined;
}

export class DeckUpdateRequest implements IDeckUpdateRequest {
    newParentId!: number;
    title!: string;
    description?: string | undefined;
    tags!: string[];
    legacyKnowledgebaseId?: string | undefined;

    constructor(data?: IDeckUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newParentId = _data["newParentId"];
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
        }
    }

    static fromJS(data: any): DeckUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeckUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newParentId"] = this.newParentId;
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        return data; 
    }
}

export interface IDeckUpdateRequest {
    newParentId: number;
    title: string;
    description?: string | undefined;
    tags: string[];
    legacyKnowledgebaseId?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}